import React from "react";

const LeadIcon = ({ className = "", size = 24, color = "#1F2937" }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="12" cy="8" r="3" stroke={color} strokeWidth="1.5" />
    <path
      d="M5 19c0-3.314 3.134-6 7-6s7 2.686 7 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default LeadIcon;
